export const SET_SECONDARY_MENU = "SET_SECONDARY_MENU"; // 设置secondary menu
export const SET_USER = "SET_USER"; // user info
export const SET_TOKEN = "SET_TOKEN"; // token
export const SET_LOADING = "SET_LOADING"; // loading
export const SET_APP_MENU = "SET_APP_MENU"; // set menu

